import {adminDealersQueries} from '@app/admin/dealers/admin-dealers-queries';
import {authGuard} from '@common/auth/guards/auth-route';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {queryClient} from '@common/http/query-client';
import {searchParamsFromUrl} from '@ui/utils/urls/search-params-from-url';
import {RouteObject} from 'react-router';

export const adminDealersRoutes: Record<string, RouteObject> = {
  index: {
    path: 'dealers',
    lazy: () => import('@app/admin/dealers/dealers-datatable'),
    shouldRevalidate: shouldRevalidateDatatableLoader,
    loader: async ({request}) => {
      // matches the backend guard on DealersController
      const redirect = authGuard({permission: 'dealers.view'});
      if (redirect) return redirect;
      return queryClient.ensureQueryData(
        adminDealersQueries.index(searchParamsFromUrl(request.url)),
      );
    },
  },
};
